import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {NbToastrService} from "@nebular/theme";
import {TranslateService} from "@ngx-translate/core";
import { Clipboard } from "@angular/cdk/clipboard";

@Component({
    selector: 'bst-copiable',
    templateUrl: './copiable.component.html',
    styleUrls: ['./copiable.component.scss'],
    standalone: false
})
export class CopiableComponent implements OnInit {

  @ViewChild('hiddenText', {static: true}) hiddenText: ElementRef;

  @Input() text: string;
  @Input() link: boolean = false;

  private readonly minwidth = 65;

  constructor(private clipboard: Clipboard,
              private translate: TranslateService,
              private notifier: NbToastrService) {

  }

  ngOnInit(): void {
  }

  get width(): number{
    return Math.max(this.minwidth, this.hiddenText.nativeElement.getBoundingClientRect().width + 30);
  }

  async copy(){
    if(this.text){
      if(!this.clipboard.copy(this.text)){
        const text = await this.translate.get('copyerror').toPromise();
        this.notifier.danger(null, text, {
          icon: 'clipboard'
        });
      }
      else {
        const text = await this.translate.get(this.link ? 'linkcopied' : 'textcopied').toPromise();
        this.notifier.success(null, text, {
          icon: 'clipboard'
        });
      }
    }
  }

  clicked(txt: HTMLInputElement) {
    txt.focus();
    txt.select();
  }
}
